module.exports = ".add-new-user .border-sec .col-md-3 {\n  height: 915px !important;\n}\n\n.users-form__title {\n  margin-top: 0;\n}\n\n.padding-unset {\n  padding-left: unset !important;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main-settings/accounts/add-account/add-account.component.css
// module id = ./src/app/main-settings/accounts/add-account/add-account.component.css
// module chunks = main